import { FormattedMessage, defineMessages } from 'react-intl';

import { Text16 } from 'atoms/typography';
import { HorizontalDivider } from 'atoms/ui/Divider';
import { useCurrentUserContext } from 'contexts/currentUser';
import { userAttributes } from 'lib/glossary';

import PhoneNumberVerificationSection from '../PhoneNumberVerification/PhoneNumberVerificationSection';
import RecoveryEmail from '../RecoveryEmail';
import SettingsSection from '../SettingsSection';
import UpdateEmail from '../UpdateEmail';
import UpdateName from '../UpdateName';

const messages = defineMessages({
  title: {
    id: 'Settings.personalInfo.title',
    defaultMessage: 'Personal Info',
  },
});

export const PersonalInfo = () => {
  const { currentUser } = useCurrentUserContext();
  return (
    <SettingsSection {...messages}>
      <UpdateName />
      <UpdateEmail />
      <HorizontalDivider />
      <RecoveryEmail />
      {currentUser && (
        <>
          <HorizontalDivider />
          <div>
            <Text16>
              <FormattedMessage {...userAttributes.phoneNumber} />
            </Text16>
            <PhoneNumberVerificationSection />
          </div>
        </>
      )}
    </SettingsSection>
  );
};

export default PersonalInfo;
